import React, { useMemo } from 'react';
import cn from 'classnames';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import style from '../../components/LoyaltyInOrder/loyaltyCopy.module.scss';
import LoyaltyImg from '@assets/images/loyalty.png';
import LoyaltyLightImg from '@assets/images/loyaltyLight.png';
import { TouchableButton } from '../../components/common/Touchable/index';
import { APP_CONFIG } from '@constants';
import { connect } from 'react-redux';


const loyaltyWelcomeScreen = ({ serverAppTheme, themeProperties, handleLoyaltySignIn, setJoinClicked, setAlreadyMem, alreadyMem, joinClicked, loyaltyInfo, flowType, orderingPortraitOrientation,  ...props }) => {
  const getTheme = themeProperties?.theme;
  const { signUpMethods, lookupMethods } = loyaltyInfo;
  const joinMessage = useMemo(() => CUSTOM_MESSAGES().LB_WOULD_YOU_LIKE_TO_JOIN_OUR_LOYALTY_PROGRAM_TODAY, []);
  const valid = ['swipe', 'scan'];

  const loyaltyJoinNow = () => {
    if (signUpMethods?.length === 1 && signUpMethods?.[0] === '') {
      return true;
    } else if ((valid.includes(signUpMethods) && signUpMethods?.length === 2)) {
      return true;
    } else if (signUpMethods?.includes('swipe') && signUpMethods?.length === 1) {
      return true;
    } else if (signUpMethods?.includes('scan') && signUpMethods?.length === 1) {
      return true;
    }
    return false;
  };
  const onClose = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
      replace: true,
    });
  }

  const loyaltyAlreadyAMember = () => {
    if (lookupMethods?.length === 1 && lookupMethods?.[0] === '') {
      return true;
    } else if ((valid.includes(lookupMethods) && lookupMethods?.length === 2)) {
      return true;
    } else if (lookupMethods?.includes('swipe') && lookupMethods?.length === 1) {
      return true;
    } else if (lookupMethods?.includes('scan') && lookupMethods?.length === 1) {
      return true;
    }
    return false;
  };

  return (
    <div className={cn('col-12 p-0 h-97 position-relative')}>
      {/* {!isLandScape &&
        <div className="w-100 pt-2 pb-1 h-20">
          {(themeProperties?.loyaltyImageUrl?.length > 0) ?
            <img src={themeProperties?.loyaltyImageUrl} alt="3"
              loading="lazy"
              className={cn('w-100 h-100')} style={{ objectFit: 'cover' }} />
            :
            (getTheme === '2') ? <img src={LoyaltyLightImg} loading="lazy"
              style={{ width: '100%', objectFit: 'cover' }} className='h-100' alt='loyaltyLightImg' /> : <img src={LoyaltyImg} style={{ width: '100%', objectFit: 'cover' }}
                loading="lazy"
                className='h-100' alt='loyaltyImg' />}
        </div>} */}

      <div className={cn('row p-2 justify-content-center align-tems-end m-auto mx-0', orderingPortraitOrientation ? 'h-60' : 'h-73')}>
        {/* {!isLandScape &&
          <div className="col-12 px-0 py-2 text-center fs_24 fw-700">
            {" "}
            {joinClicked
              ? LABEL().LS_SIGN_UP_TO_LOYALTY
              : alreadyMem
                ? LABEL().LS_SIGN_IN_TO_LOYALTY
                : ""}
          </div>} */}
        <div className={cn("fw-400 fs_32 p-1 text-center d-flex align-items-center")} style={{ color: serverAppTheme?.primary_text }}>{joinMessage}</div>
      </div>

      <div className={cn("w-100 d-flex align-items-end position-absolute pt-3 h-20")} style={{bottom : orderingPortraitOrientation ? '5px' : ''}}>
        <div className={cn('pt-2 mx-auto', orderingPortraitOrientation ? 'w-100' : 'w-60')}>
          <div className={cn('d-flex justify-content-between', loyaltyJoinNow() && 'pb-1')} style ={{height: '68px'}}>
            {!loyaltyJoinNow() &&
              <TouchableButton type="button" disabled={loyaltyJoinNow()} className={cn(loyaltyAlreadyAMember() ? 'w-100' : 'w-50 mr-2', 'fw-600 btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color btn68')} onClick={(event) => { event.preventDefault(); handleLoyaltySignIn('signUp'); setJoinClicked(true); setAlreadyMem(false) }} rippleEffect={true} style={{backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color}}>
                {LABEL().LB_JOIN_NOW}
              </TouchableButton>}
            {!loyaltyAlreadyAMember() &&
              <TouchableButton type="button" disabled={loyaltyAlreadyAMember()} className={cn(loyaltyJoinNow() ? 'w-100' : 'w-50', 'pl-2 pr-2 fw-600 btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color btn68', style.lineheight)} onClick={(event) => { event.preventDefault(); handleLoyaltySignIn('signIn'); setJoinClicked(false); setAlreadyMem(true) }} rippleEffect={true} style={{backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color}}>
                {LABEL().LB_ALREADY_A_MEMBER}
              </TouchableButton>
            }
          </div>
          <div className={cn(loyaltyJoinNow() ? 'pt-1' : (orderingPortraitOrientation ? 'pt-2': 'pt-3'))}>
            <TouchableButton
              type="button"
              className={cn('w-100 btn68 fw-600 btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color', !loyaltyJoinNow() && 'mr-2',
                loyaltyAlreadyAMember() && 'w-100')}
              onClick={(event) => { event.preventDefault(); onClose() }}
              rippleEffect={true}
              style={{backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color}}
            >
              {LABEL().LB_NOT_NOW}
            </TouchableButton>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  orderingPortraitOrientation: state.orders.orderingPortraitOrientation
});

export default connect(mapStateToProps)(loyaltyWelcomeScreen);
